import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';

@Component({
  selector: 'app-register-dialog',
  templateUrl: './register-dialog.component.html',
  styleUrls: ['./register-dialog.component.css']
})
export class RegisterDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<RegisterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _eventHandlingService:EventHandlingService,
  ) { }

  ngOnInit(): void {
  }

  closeDialog = () => {
    this._eventHandlingService.updateChangeAction({});
    this.dialogRef.close();
  }

}
